import type { ForwardedRef } from 'react'
import { forwardRef } from 'react'
import { AudioWaveform } from '../Audiowaveform'
import {
  StyledRecorderAudioWaveformWrapper,
  StyledRecorderWaveform,
  StyledRecorderWaveformLine
} from './RecorderWaveform.styles'

export interface RecorderWaveformProps {
  waveformData: number[]
  numberOfBars: number
}

export const RecorderWaveform = forwardRef(function RecorderWaveform(
  props: RecorderWaveformProps,
  ref: ForwardedRef<HTMLDivElement>
): JSX.Element {
  return (
    <StyledRecorderWaveform ref={ref}>
      <StyledRecorderWaveformLine />
      <StyledRecorderAudioWaveformWrapper>
        <AudioWaveform
          size={'l'}
          numberOfBars={props.numberOfBars}
          data={props.waveformData}
          variant={'elapsed'}
        />
      </StyledRecorderAudioWaveformWrapper>
    </StyledRecorderWaveform>
  )
})
